import { z } from 'zod';
import { FeatureDetailSchema } from '../types/features.js';

// GET /data-connections/:identifier/features?brandId=
export namespace GetDataConnectionFeatures {
  export const paramsSchema = z.object({
    identifier: z.uuid(),
  });

  export const querySchema = z.object({
    brandId: z.string().optional(),
  });

  export const responseSchema = z.object({
    features: z.array(FeatureDetailSchema),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

// PUT /data-connections/:identifier/feature
export namespace UpsertDataConnectionFeature {
  export const paramsSchema = z.object({
    identifier: z.uuid(),
  });

  export const requestBodySchema = z.object({
    propName: z.string(),
    value: z.string(),
    brandId: z.string().nullable().optional(),
  });

  export const responseSchema = z.object({
    feature: FeatureDetailSchema,
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

// GET /data-connections/:identifier/brands
export namespace GetDataConnectionBrands {
  export const paramsSchema = z.object({
    identifier: z.uuid(),
  });

  export const responseSchema = z.object({
    brands: z.array(
      z.object({
        id: z.number(),
        identifier: z.string(),
        name: z.string(),
      })
    ),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Response = z.infer<typeof responseSchema>;
}